import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import Container from '@/components/base/Container';
import { navItems, siteInfo, tickerItems } from '@/mocks/site';

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const marqueeItems = [...tickerItems, ...tickerItems];

  return (
    <header className="sticky top-0 z-50">
      <div className="bg-foreground-950">
        <Container className="flex h-9 items-center gap-3">
          <span className="flex shrink-0 items-center gap-1.5 text-[11px] font-medium tracking-wide text-accent-400">
            <i className="ri-flashlight-fill"></i>
            追踪快报
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="kl-marquee flex w-max items-center gap-10 whitespace-nowrap text-[12px] text-background-200">
              {marqueeItems.map((item, index) => (
                <span key={index} className="flex items-center gap-2">
                  <span className="h-1 w-1 rounded-full bg-accent-400"></span>
                  {item}
                </span>
              ))}
            </div>
          </div>
          <Link
            to="/about#contact"
            className="hidden shrink-0 cursor-pointer items-center gap-1 text-[11px] text-background-300 transition-colors hover:text-accent-400 md:flex"
          >
            <i className="ri-mail-send-line"></i>
            提供线索
          </Link>
        </Container>
      </div>

      <div
        className={`border-b bg-background-50/95 backdrop-blur transition-colors ${
          scrolled ? 'border-background-200' : 'border-transparent'
        }`}
      >
        <Container className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex cursor-pointer items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-600 font-heading text-lg font-bold text-background-50">
              料
            </span>
            <span className="flex flex-col leading-tight">
              <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">{siteInfo.name}</span>
              <span className="hidden text-[11px] tracking-wide text-foreground-500 sm:block">{siteInfo.slogan}</span>
            </span>
          </Link>

          <nav aria-label="主导航" className="hidden items-center gap-1 md:flex">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `cursor-pointer whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary-50 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/about#contact"
              className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700 md:inline-flex"
            >
              <i className="ri-notification-3-line"></i>
              订阅更新
            </Link>
            <button
              type="button"
              aria-label="打开菜单"
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((prev) => !prev)}
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 md:hidden"
            >
              <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
            </button>
          </div>
        </Container>
      </div>

      {menuOpen && (
        <div className="border-b border-background-200 bg-background-50 md:hidden">
          <nav aria-label="移动端导航" className="flex flex-col px-4 py-3">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `cursor-pointer rounded-md px-3 py-3 text-sm font-medium transition-colors ${
                    isActive ? 'bg-primary-50 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/about#contact"
              className="mt-2 inline-flex cursor-pointer items-center justify-center gap-1.5 rounded-md bg-primary-600 px-4 py-3 text-sm font-medium text-background-50"
            >
              <i className="ri-notification-3-line"></i>
              订阅更新
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}